// extracted by mini-css-extract-plugin
export default {"container":"Q_b","authorInfo":"Q_c0","title":"Q_c1","socials":"Q_c2","expertise":"Q_c3","posts":"Q_c4","biography":"Q_c5"};